/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} House_Such_Shrimp_ReadInputs */

const fr_house_such_shrimp_read = /** @type {(inputs: House_Such_Shrimp_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scores soumis`)
};

/**

* @param {House_Such_Shrimp_ReadInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const house_such_shrimp_read = /** @type {((inputs?: House_Such_Shrimp_ReadInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<House_Such_Shrimp_ReadInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_house_such_shrimp_read(inputs)
});